// Fee & Obligation PR-4b — §17.4 enforcement-administration time logging.
// HTTP transport; hooks in @/hooks/portfolioAdmin/useWorkoutTime wrap these.

import { api } from "../client";

export interface WorkoutTimeLogEntryDto {
  id: string;
  workDate: string; // yyyy-MM-dd
  hours: number;
  activityCode: string;
  note: string | null;
  rateAtLog: number;
  amount: number;
  rolledUp: boolean;
  rolledUpIntoCostId: string | null;
  createdAt: string;
  loggedByUserId: string | null;
}

export interface WorkoutTimeLogViewDto {
  entries: WorkoutTimeLogEntryDto[];
  unbilledHours: number;
  unbilledAmount: number;
  currentHourlyRate: number;
  projectedCurrentMonthAmount: number;
  canLog: boolean;
  cannotLogReason: string | null;
}

export interface LogWorkoutTimeRequest {
  workDate: string; // yyyy-MM-dd
  hours: number;
  activityCode: string;
  note?: string | null;
}

export const workoutTimeApi = {
  activityCodes: () =>
    api.get<string[]>(`/portfolio-admin/workout-time/activity-codes`),
  getForCase: (caseId: string) =>
    api.get<WorkoutTimeLogViewDto>(
      `/portfolio-admin/default-cases/${caseId}/time-log`,
    ),
  log: (caseId: string, body: LogWorkoutTimeRequest) =>
    api.post<WorkoutTimeLogEntryDto>(
      `/portfolio-admin/default-cases/${caseId}/time-log`,
      body,
    ),
  // On-demand billing — roll the case's UNBILLED time into recoverable
  // WorkoutCostEntries now (one per work-month) instead of waiting for the
  // monthly close-of-month rollup. Returns the refreshed view.
  bill: (caseId: string) =>
    api.post<WorkoutTimeLogViewDto>(
      `/portfolio-admin/default-cases/${caseId}/time-log/bill`,
      {},
    ),
};
